/**
 * @generated SignedSource<<b2452284d17414ffda90acf641146381>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RichTextCell_issue$data = {
  readonly " $fragmentSpreads": FragmentRefs<"richTextFullIssue">;
  readonly " $fragmentType": "RichTextCell_issue";
};
export type RichTextCell_issue$key = {
  readonly " $data"?: RichTextCell_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"RichTextCell_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    }
  ],
  "kind": "Fragment",
  "name": "RichTextCell_issue",
  "selections": [
    {
      "condition": "isDensityFull",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "richTextFullIssue"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "0f41157de46ac7acf87136a65f15a17f";

export default node;
